module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#photostory",
      toString: function () {
        return this.url;
      }
    }